<template>

</template>

<script>
    export default {
        name: "galeriaImagenes",
        props: {
            imagenes: [],
        },
        data() {
            return {
                urlImagenes: 'http://mirandav2.local/imagenes/',
                visible: false,
                imgs: []

            }
        },
        methods:{
            handleHide(){

            },
            showImg(){

            }
        }
    }
</script>

<style scoped>

</style>
